import React, { Component } from 'react';

class AssetEdit extends Component {
  render() {
    return <div>AssetEdit</div>;
  }
}

export default AssetEdit;
